import { Injectable } from '@angular/core';
import {
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import {
    ConfigurationEntryValueType,
    ICredentialStoreConfigurationEntry,
} from '@models';

@Injectable({
    providedIn: 'root',
})
export class DynamicConfigurationFormService {
    public toFormGroup(configurationEntries: ICredentialStoreConfigurationEntry[], data?: Record<string, any>) {
        const group: any = {};

        configurationEntries.forEach(configurationEntry => {
            if (configurationEntry.valueType === ConfigurationEntryValueType.Section) {
                const subValue = data ? data[configurationEntry.key] : data;
                group[configurationEntry.key] = this.toFormGroup(configurationEntry.configurations!, subValue);
            } else {
                const value = data && data[configurationEntry.key] || configurationEntry.defaultValue;
                const validators = [];

                if (configurationEntry.isMandatory) {
                    validators.push(Validators.required);
                }

                group[configurationEntry.key] = new FormControl(value, validators);
            }
        });

        return new FormGroup(group);
    }
}
